import React from "react";
import { Alert, Avatar, AvatarGroup, ButtonBase, IconButton, ListItem, ListItemAvatar, ListItemButton, ListItemText, Menu, MenuItem, Snackbar, Tooltip, Typography } from "@mui/material";
import { Delete } from "@mui/icons-material";
import { useProfile } from "../common/useProfile";

export default function MembrosAvatarGroup(props) {
    const { membros, remove, action } = props;
    const prof = useProfile();
    const [lst, setLst] = React.useState(membros);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const [msg, setMsg] = React.useState({
        severity:'success',
        txt:'',
    })
    const [openSnack, setOpenSnack] = React.useState(false);


    const handleCloseSnack = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnack(false);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    function handleMembros(event) {
        setAnchorEl(event.currentTarget);
    }
    function handleDelete(row) {
        if (remove) remove(row);
        handleClose();
    }
    function handleMemberClick(row) {
        console.log('>>>handleMemberClick<<<', row);
        if (action) action(row);
    }
    function temPermissaoAdm() {
        if (prof.temAcesso("ProjectAdm")) return true;
        if (prof.temAcesso("PrjAdm")) return true;
        if (prof.temAcesso("PrjAddMembros")) return true;
        return false;
    }
    return (
        <ButtonBase
            component="label"
            role={undefined}
            tabIndex={-1} // prevent label from tab focus
            aria-label="Avatar image"
            sx={{
                borderRadius: '40px',
                '&:has(:focus-visible)': {
                    outline: '2px solid',
                    outlineOffset: '2px',
                },
            }}
        >
            <AvatarGroup max={4} onClick={handleMembros}>
                {lst && lst.map((row, id) =>
                    <Tooltip key={id} title={row.nome}>
                        <Avatar sx={{ width: 30, height: 30 }} src={`/api/security/user/avatarImageByLogin/${row.login}`} />
                    </Tooltip>
                )}
            </AvatarGroup>
            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                slotProps={{
                    list: {
                        'aria-labelledby': 'basic-button',
                    },
                }}
            >
                {lst && lst.map((row, id) => (
                    <ListItem key={id}
                        // disableGutters
                        secondaryAction={temPermissaoAdm() &&
                            <Tooltip title="Remover do kanban">
                                <IconButton aria-label="comment" onClick={() => handleDelete(row)}>
                                    <Delete />
                                </IconButton>
                            </Tooltip>
                        }
                    >
                        <ListItemButton dense disableGutters onClick={() => {
                            if (temPermissaoAdm()) handleMemberClick(row);
                            else {
                                setOpenSnack(true);
                                setMsg({
                                    severity:'warning',
                                    txt:"Sem premissão!"
                                })
                            }
                        }}>
                            <ListItemAvatar>
                                <Avatar alt={row.login} src={`/api/security/user/avatarImageByLogin/${row.login}`} />
                            </ListItemAvatar>
                            <ListItemText
                                primary={row.nome}
                                secondary={
                                    <React.Fragment>
                                        <Typography
                                            component="span"
                                            variant="body2"
                                            sx={{ color: 'text.primary', display: 'inline' }}
                                        >
                                            {row.email}
                                        </Typography>
                                    </React.Fragment>
                                }
                            />
                        </ListItemButton>
                    </ListItem>
                ))}
            </Menu>
            <Snackbar open={openSnack} autoHideDuration={6000} onClose={handleCloseSnack}>
                <Alert
                    onClose={handleCloseSnack}
                    severity={msg.severity}
                    variant="filled"
                    sx={{ width: '100%' }}
                >
                    {msg.txt}
                </Alert>
            </Snackbar>
        </ButtonBase>
    )

}